import blueThemegirl from '../assets/svg/about/blueTheme-girl.svg'
import blueThemeboy from '../assets/svg/about/blueTheme-boy.svg'
import bwThemeboy from '../assets/svg/about/bwTheme-boy.svg'
import bwThemegirl from '../assets/svg/about/bwTheme-girl.svg'
import greenThemeboy from '../assets/svg/about/greenTheme-boy.svg'
import greenThemegirl from '../assets/svg/about/greenTheme-girl.svg'
import orangeThemeboy from '../assets/svg/about/orangeTheme-boy.svg'
import orangeThemegirl from '../assets/svg/about/orangeTheme-girl.svg'
import pinkThemeboy from '../assets/svg/about/pinkTheme-boy.svg'
import pinkThemegirl from '../assets/svg/about/pinkTheme-girl.svg'
import purpleThemeboy from '../assets/svg/about/purpleTheme-boy.svg'
import purpleThemegirl from '../assets/svg/about/purpleTheme-girl.svg'
import redThemeboy from '../assets/svg/about/redTheme-boy.svg'
import redThemegirl from '../assets/svg/about/redTheme-girl.svg'
import yellowThemeboy from '../assets/svg/about/yellowTheme-boy.svg'
import yellowThemegirl from '../assets/svg/about/yellowTheme-girl.svg'

import eduBlue from '../assets/svg/education/eduBlue.svg'
import eduGreen from '../assets/svg/education/eduGreen.svg'
import eduBlack from '../assets/svg/education/eduBlack.svg'
import eduOrange from '../assets/svg/education/eduOrange.svg'
import eduPink from '../assets/svg/education/eduPink.svg'
import eduPurple from '../assets/svg/education/eduPurple.svg'
import eduRed from '../assets/svg/education/eduRed.svg'
import eduYellow from '../assets/svg/education/eduYellow.svg'

import expBlue from '../assets/svg/experience/expBlue.svg'
import expGreen from '../assets/svg/experience/expGreen.svg'
import expBlack from '../assets/svg/experience/expBlack.svg'
import expOrange from '../assets/svg/experience/expOrange.svg'
import expPink from '../assets/svg/experience/expPink.svg'
import expPurple from '../assets/svg/experience/expPurple.svg'
import expRed from '../assets/svg/experience/expRed.svg'
import expYellow from '../assets/svg/experience/expYellow.svg'
import expJordi from '../assets/gif/jordihashbrown.gif'

import contactsBlue from '../assets/svg/contacts/contactsBlue.svg'
import contactsGreen from '../assets/svg/contacts/contactsGreen.svg'
import contactsBlack from '../assets/svg/contacts/contactsBlack.svg'
import contactsOrange from '../assets/svg/contacts/contactsOrange.svg'
import contactsPink from '../assets/svg/contacts/contactsPink.svg'
import contactsPurple from '../assets/svg/contacts/contactsPurple.svg'
import contactsRed from '../assets/svg/contacts/contactsRed.svg'
import contactsYellow from '../assets/svg/contacts/contactsYellow.svg'


export { 
    blueThemegirl, blueThemeboy, bwThemeboy, bwThemegirl, greenThemeboy, greenThemegirl, orangeThemeboy, 
    orangeThemegirl, pinkThemeboy, pinkThemegirl, purpleThemeboy, purpleThemegirl, redThemeboy, redThemegirl,
    yellowThemeboy,yellowThemegirl,eduBlue,eduBlack,eduGreen,eduOrange,eduPink,eduPurple,eduRed,eduYellow,
    expBlue,expBlack,expGreen,expOrange,expPink,expPurple,expRed,expYellow,contactsBlue,contactsBlack,
    contactsGreen,contactsOrange,contactsPink,contactsPurple,contactsRed,contactsYellow, expJordi
}